import { z } from 'zod'

export enum MedChronSourceProvider {
  LEGACY = 'legacy',
  USER_FILES = 'user_files',
}

export const MedChronLegacySourceRefSchema = z.object({
  provider: z.literal(MedChronSourceProvider.LEGACY),
  source_id: z.string(),
  file_path: z.string(),
  display_name: z.string(),
})

export const MedChronUserFilesSourceRefSchema = z.object({
  provider: z.literal(MedChronSourceProvider.USER_FILES),
  source_id: z.string(),
  display_name: z.string(),
})

export const MedChronSourceRefSchema = z.discriminatedUnion('provider', [MedChronLegacySourceRefSchema, MedChronUserFilesSourceRefSchema])

export type MedChronSourceRef = z.infer<typeof MedChronSourceRefSchema>
